/** Confirmation toasts: short, specific, saying what happened. */
export const SUCCESS_MESSAGES = {
  copied: (text: string) => `Copied ${text}`,

  payment: {
    received: "Payment received",
    cashOnDelivery: "Cash on delivery",
    walletCovered: "Paid from wallet",
  },

  order: {
    newOrder: (orderNumber: string) => `New order ${orderNumber}`,
    cancelled: (orderNumber: string) => `Order ${orderNumber} cancelled`,
    paymentFailed: (orderNumber: string) => `Payment failed for ${orderNumber}`,
  },

  ticket: {
    newTicket: (ticketNumber: string) => `New support ticket ${ticketNumber}`,
  },

  invoice: {
    generated: (count: number) =>
      count === 0
        ? "Every delivered order already has an invoice"
        : `Issued ${count} ${count === 1 ? "invoice" : "invoices"}`,
  },

  coupon: {
    created: (code: string) => `${code} created`,
    updated: (code: string) => `${code} updated`,
    paused: (code: string) => `${code} paused`,
    resumed: (code: string) => `${code} resumed`,
    deleted: (code: string) => `${code} deleted`,
    applied: (code: string) => `${code} applied`,
  },
} as const;
